class InStockProductCardForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.form.querySelector('.product-selector__submit');
    this.cartDrawer = document.querySelector('cart-drawer');

    this.form.addEventListener(
      'submit',
      this.onSubmitHandler.bind(this)
    );
  }

  onSubmitHandler(event) {
    event.preventDefault();
    this.submitButton.classList.add('disabled');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers['Content-Type'] = 'application/json';

    const variantInput =
      this.querySelector('[name="variant"]') ||
      this.querySelector('[data-selected="true"]');

    const variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      this.handleErrorMessage('Please select an option.');
      this.submitButton.classList.remove('disabled');
      return;
    }

    const itemsData = [
      {
        id: variantId,
        quantity: 1
      }
    ];

    const requestData = {
      items: itemsData,
      sections: this.cartDrawer
        .getSectionsToRender()
        .map(section => section.section),
      sections_url: window.location.pathname
    };

    config.body = JSON.stringify(requestData);

    fetch(`${routes.cart_add_url}`, config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }

        this.cartDrawer.renderContents(response);
      })
      .catch(() => {})
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.querySelector('[data-error-wrapper]');
    if (!errorWrapper) return;
    errorWrapper.classList.toggle('hidden', !errorMessage);
    errorWrapper.textContent = errorMessage || '';
  }

  toggleAddButton(disable, text) {
    [this.submitButton].forEach(submitButton => {
      if (!submitButton) return;

      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        if (text) submitButton.textContent = text;
      } else {
        submitButton.removeAttribute('disabled');
        submitButton.textContent = window.variantStrings.addToCart;
      }
    });
  }
}

if (!window.customElements.get('in-stock-product-card-form')) {
  window.customElements.define(
    'in-stock-product-card-form',
    InStockProductCardForm
  );
}

class InStockProductSelector extends HTMLElement {
  constructor() {
    super();

    this.select = this.querySelector('[data-variant-selector]');
    if (this.select) {
      this.select.addEventListener('change', () =>
        this._handleVariantSelectChange()
      );
    }

    this.radioInputs = this.querySelectorAll('[data-variant-radio]');
    if (this.radioInputs.length) {
      this.radioInputs.forEach(input => {
        input.addEventListener('change', () =>
          this._handleVariantRadioChange(input)
        );
      });
    }
  }

  _handleVariantSelectChange() {
    this.variantId = this.select.value;
    this._renderProductInfo();
  }

  _handleVariantRadioChange(input) {
    this.radioInputs.forEach(radio => {
      radio.nextElementSibling.classList.remove('is-active');
      radio.dataset.selected = 'false';
    });

    input.nextElementSibling.classList.add('is-active');
    input.dataset.selected = 'true';

    this.variantId = input.value;
    this._renderProductInfo();
  }

  _renderProductInfo() {
    const productPriceContainer = document.querySelector(
      `#Product-Price-${this.dataset.productId}`
    );

    if (!productPriceContainer) return;

    const compareAtPrice = productPriceContainer.querySelector('del');
    const productPrice =
      productPriceContainer.querySelector('[data-price-element]');
    const savePercent = productPriceContainer.querySelector('.sale');

    if (!productPrice) return;

    fetch(`${this.dataset.url}.js`)
      .then(response => response.json())
      .then(product => {
        const targetId = String(this.variantId);
        const newVariant = product.variants.find(
          variant => String(variant.id) === targetId
        );

        if (!newVariant) return;

        const formatMoney = cents => {
          const value = cents / 100;
          return value % 1 === 0
            ? `$${value}`
            : `$${value.toFixed(2)}`;
        };

        // Update compare-at price + save badge
        if (compareAtPrice) {
          if (
            newVariant.compare_at_price &&
            newVariant.compare_at_price > newVariant.price
          ) {
            compareAtPrice.innerHTML = `<lomoney>${formatMoney(
              newVariant.compare_at_price
            )}</lomoney>`;
            compareAtPrice.style.display = '';

            if (savePercent) {
              const pct = Math.round(
                ((newVariant.compare_at_price - newVariant.price) * 100) /
                  newVariant.compare_at_price
              );
              savePercent.innerText = `SAVE ${pct}%`;
            }
          } else {
            // No compare-at (or not a real discount)
            compareAtPrice.style.display = 'none';
            if (savePercent) savePercent.innerText = '';
          }
        }

        // Update main price
        productPrice.innerHTML = `<lomoney>${formatMoney(
          newVariant.price
        )}</lomoney>`;
      })
      .catch(() => {});
  }
}

if (!window.customElements.get('in-stock-product-selector')) {
  window.customElements.define(
    'in-stock-product-selector',
    InStockProductSelector
  );
}